import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { captureSlugAcquisition } from '../hooks/useAcquisitionTracking';

/**
 * Landing route for path-based attribution: /r/<slug>
 *
 * Stamps first-touch acquisition with source='influencer' and
 * campaign=<slug>, then redirects to the root so the visitor hits the
 * normal landing experience. Path-based on purpose — query strings get
 * stripped by Telegram/IG/TikTok in-app browsers and by some OAuth
 * round-trips, but path segments survive.
 */
const SlugLanding: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    if (slug) captureSlugAcquisition(slug);
  }, [slug]);

  return <Navigate to="/" replace />;
};

export default SlugLanding;
